import stbtcIcon from "#/assets/tokens/stbtc-token.svg"
import {
  selectDepositAmount,
  selectDepositStatus,
  selectTotalMintedAmount,
  useDappSelector,
} from "#/redux-state"
import ModalContainer from "#/shared/components/ModalContainer"
import { useFriendlyTokenAmount, useStbtcManageModal } from "#/shared/hooks"
import { MezoModalProps } from "#/shared/types"

import StbtcSuccessModal from "../StbtcSuccessModal"

import StbtcManageModalBase from "./StbtcManageModalBase"

export default function StbtcManageModal({ isOpen, onClose }: MezoModalProps) {
  const totalMintedTokenAmount = useDappSelector(selectTotalMintedAmount)

  const {
    deposits,
    currentlySelectedDeposit,
    onDepositCarouselChange,
    closeModal,
  } = useStbtcManageModal(isOpen, onClose)

  const depositStatus = useDappSelector(selectDepositStatus)
  const depositAmount = useDappSelector(selectDepositAmount)

  const { hasManyDecimals, displayedDepositAmount } =
    useFriendlyTokenAmount(depositAmount)

  return (
    <ModalContainer isOpen={isOpen} onClose={closeModal} width="522px">
      {depositStatus === "completed" ? (
        <StbtcSuccessModal
          icon={stbtcIcon}
          amount={displayedDepositAmount}
          fullAmount={depositAmount}
          hasTooltip={hasManyDecimals}
          amountLabel="stBTC"
        >
          stBTC Return Completed
        </StbtcSuccessModal>
      ) : (
        <StbtcManageModalBase
          deposits={deposits}
          totalMintedTokenAmount={totalMintedTokenAmount}
          selectedDeposit={currentlySelectedDeposit}
          onDepositCarouselChange={onDepositCarouselChange}
        />
      )}
    </ModalContainer>
  )
}
